export const ProjectEvents = {
	LogoAdded: 'LogoAdded',
	LogoRemoved: 'LogoRemoved',

	CrewPermissionChanged: 'CrewPermissionChanged',
};
